import axios from "axios";
import config from "../config";
import authService from "./authService";

export default axios.create({
  baseURL: config.baseURL,
  headers: {
    "Content-Type": "application/json",
    Authorization: `Bearer ${authService.getToken()}`,
  },
});
